import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
    paginationWrapper: {
        display: 'flex',
        margin: theme.spacing(3, 0),
        [theme.breakpoints.up('sm')]: {
            justifyContent: 'flex-end',
        },
        [theme.breakpoints.down('xs')]: {
            justifyContent: 'center',
        }
    },
    title: {
        width: '100%',
        height: 'auto',
        padding: '0 7.5%',
        margin: '1% 0',
        [theme.breakpoints.down('769')]: {
            width: '90%',
        },
    },
    subtitle: {
        borderLeft: '7px solid #F5B750',
        fontSize: 26,
        color: '#344450',
        fontWeight: 'bold',
        padding: '2% 3%',
        margin: '1% 0',
        [theme.breakpoints.down('1100')]: {
            borderLeft: '5px solid #F5B750',
            fontSize: 22,
        },
        [theme.breakpoints.down('769')]: {
            borderLeft: '3px solid #F5B750',
            fontSize: 18,
        }
    },
    tab: {
        display: 'flex',
        width: '85%',
        margin: '0 auto',
        color: '#344450',
        backgroundColor: '#E4E4E4',
        [theme.breakpoints.down('769')]: {
            width: '100%'
        }
    },
    item: {
        width: 'auto',
        padding: '15px 0',
        cursor: 'pointer',
        textAlign: 'center',

        minWidth: `25%`,
        [theme.breakpoints.down('1100')]: {
            fontSize: 14,
            padding: '14px 0',
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 12,
            padding: '12px 0',
        },
        [theme.breakpoints.down('400')]: {
            fontSize: 9,
            padding: '10px 0',
        }
    },
    itemSelected: {
        color: 'white',
        backgroundColor: '#344450'
    },
    container: {
        width: '85%',
        height: 'auto',
        minHeight: 300,
        marginBottom: '3%',
        backgroundColor: '#F2F3F2',
        display: 'flex',
        flexDirection: 'column',
        margin: '0 auto',
        [theme.breakpoints.down('769')]: {
            width: '100%'
        }
    },
    newsContent: {
        display: 'flex',
        flexDirection: 'column',
        width: '85%',
        [theme.breakpoints.down('1100')]: {
            width: '95',
        },
        [theme.breakpoints.down('400')]: {
            width: '100%',
        },
        margin: '0 auto'
    },
    newsContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        [theme.breakpoints.down('600')]: {
            justifyContent: 'space-around'
        },
    },
    newsBox: {
        width: '30%',
        cursor: 'pointer',
        [theme.breakpoints.down('1100')]: {
            width: '45%',
        },
        [theme.breakpoints.down('600')]: {
            width: '90%',
        },
        backgroundColor: '#FFFFFF',
        padding: 10,
        marginBottom: 15,
        boxShadow: '0px 3px 2px rgb(177, 174, 174)',
        minWidth: 240,
    },
    newsDate: {
        color: '#FFFFFF',
        backgroundColor: '#F5B750',
        position: 'absolute',
        padding: 10,
        fontSize: 14,
        textAlign: 'center',
        borderBottomLeftRadius: 6,
        borderBottomRightRadius: 6,
        marginTop: -10,
        marginLeft: 8,
        zIndex: 1
    },
    newsImage: {
        height: 'auto',
        width: '100%',
        marginBottom: 10
    },
    newsText: {
        height: 100
    },
    newsTitle: {
        textAlign: 'right',
        lineHeight: '1.7em',
        fontSize: 18,
        fontWeight: 'bold',
        [theme.breakpoints.down('1100')]: {
            fontSize: 16,
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 14,
        },
        color: '#344450'
    },
    newsDescription: {
        textAlign: 'right',
        lineHeight: '1.5em',
        fontSize: 16,
        [theme.breakpoints.down('1100')]: {
            fontSize: 14,
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 12,
        },
        color: '#344450',
        '& p': {
            margin: 0
        }
    },
    interactionsSummary: {
        color: '#344450',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        margin: '3% auto',
    },
    interactionsCount: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '0 5px',
        justifyContent: 'flex-end'
    },
    root: {
        '& .MuiInput-underline:after': {
            borderColor: '#F5B750',
            borderRadius: 0
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'transparent'
            },
            '&:hover fieldset': {
                borderColor: 'transparent'
            },
            '&.Mui-focused fieldset': {
                borderColor: '#F5B750',
                borderRadius: 0
            },
            '&.Mui-focused .MuiInputAdornment-root .MuiSvgIcon-root': {
                color: '#F5B750'
            },
        },
        backgroundColor: '#FFFFFF',
        margin: 'auto',
        marginTop: 20,
        marginBottom: 20,
        [theme.breakpoints.down('769')]: {
            marginTop: 10,
            marginBottom: 10,
        },
        width: '100%',
        [theme.breakpoints.down('600')]: {
            width: '90%',
        }
    },
    multilineColor: {
        color: '#344450',
        fontSize: 16,
        [theme.breakpoints.down('1100')]: {
            fontSize: 14,
        },
        [theme.breakpoints.down('769')]: {
            fontSize: 12,
            height: 30
        },
    }
}))

export default useStyles